import { render, staticRenderFns } from "./finallist.vue?vue&type=template&id=53f354d1"
import script from "./finallist.vue?vue&type=script&lang=js"
export * from "./finallist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports